import { convertToArray } from 'utils/converters/convertToArray';
import modelsResolver from 'utils/api/models/utils/modelsResolver';
import { SingleAccount } from 'utils/api/models/accounts/singleAccount';

export type Accounts = {
	_accounts: any;
	accounts: SingleAccount[];
};

const model: types.models.InputModel = {
	_accounts: ['response.getNumbersWithChildsResponse.numbers', []],
	accounts: function(model: Accounts) {
		return convertToArray(model._accounts).map((account, index) => {
			if (typeof account === 'object') {
				account.id = index;
				return modelsResolver(account, 'singleAccount');
			}
			return false;
		});
	},
};

export default model;
